import type {IRegister} from "../types/IRegister";

export const registerFormDefaultValues: IRegister = {
    email: "",
    password: "",
    marketing_email: false,
    marketing_sms: false
};
import type {IRegister} from "../types/IRegister";

export const registerFormDefaultValues: IRegister = {
    email: "",
    password: "",
    marketing_email: false,
    marketing_sms: false
};
